declare global {
  interface Window {
    FIINDER_COMPANY_TOKEN?: string
  }
}

export type AuthRequest = {
  url: string
  method: string
}

export type AuthStrategy = {
  getHeaders: (request: AuthRequest) => Promise<Record<string, string>>
}

function getDefaultToken(): string {
  if (typeof window === "undefined") {
    throw new Error("FIINDER_COMPANY_TOKEN is not available on the server")
  }
  const token = window.FIINDER_COMPANY_TOKEN
  if (!token) {
    throw new Error("FIINDER_COMPANY_TOKEN is not set on window")
  }
  return token
}

const defaultStrategy: AuthStrategy = {
  async getHeaders() {
    const token = getDefaultToken()
    return {
      Authorization: `Bearer ${token}`,
    }
  },
}

let currentStrategy: AuthStrategy = defaultStrategy

export function setAuthStrategy(strategy: AuthStrategy | null | undefined) {
  currentStrategy = strategy ?? defaultStrategy
}

export function resetAuthStrategy() {
  currentStrategy = defaultStrategy
}

export async function resolveAuthHeaders(request: AuthRequest) {
  return currentStrategy.getHeaders(request)
}
